import { CommonModule }                      from '@angular/common';
import { NgModule }                          from '@angular/core';
import { EntityActiveSortPropertyComponent } from '@shared/components/entity-active-sort-property/entity-active-sort-property.component';


@NgModule( {
	declarations: [
		EntityActiveSortPropertyComponent
	],
	imports: [
		CommonModule
	],
	exports: [
		EntityActiveSortPropertyComponent
	]
} )
export class EntityActiveSortPropertyModule {}
